import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import store, { history } from '../redux/store';
import Router from '../pages';
import '../styles/style.scss';

const theme = createMuiTheme({
  palette: {
    primary: { main: '#004987' },
    secondary: { main: '#C1D42F' },
    gray: {
      700: '#666',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      xs_375: 375,
      xs_425: 425,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

function App() {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ThemeProvider theme={theme}>
          <Router />
        </ThemeProvider>
      </ConnectedRouter>
    </Provider>
  );
}

export default App;
